import { getDeliveryFeeList, saveDeliveryFee, deleteDeliveryFee } from '@/api/delivery'
export default {
  state: {

  },
  actions: {
    getDeliveryFeeList ({ commit }, payload) {
      return new Promise(resolve => {
        getDeliveryFeeList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveDeliveryFee ({ commit }, payload) {
      return new Promise(resolve => {
        saveDeliveryFee(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    deleteDeliveryFee ({ commit }, payload) {
      return new Promise(resolve => {
        deleteDeliveryFee(payload).then(res => {
          resolve(res.data)
        })
      })
    }
  },
  getters: {

  },
  mutations: {

  }
}
